export default __webpack_public_path__ + "static/media/BIFI-ETH.6edcc459.png";